module.exports = __webpack_public_path__ + "static/media/TERMINOS Y CONDICIONES ATELIER FASHION SHOP.0fbecba6.pdf";